// Übersetzungen, die im Code verwendet wurden, aber in keiner Sprachdatei standen (ergänzt). Flache Schlüssel, wird in fieldMapping.js eingemischt.
const de = {
  bruttopreis: "Bruttopreis",
  nettopreis: "Nettopreis",
  couponNotAvailableForOffer: "Gutscheine sind bei eigenem Preisvorschlag nicht anwendbar.",
  discardChanges: "Verwerfen",
  saveChanges: "Speichern",
  errorCancelReasonRequired: "Bitte gib einen Stornogrund an.",
  expandCoupon: "Gutschein aufklappen",
  minimizeCoupon: "Gutschein einklappen",
  genericSaveError: "Speichern fehlgeschlagen. Bitte versuche es erneut.",
  loadingAria: "Wird geladen",
  manageServicesTitle: "Zusatzleistungen verwalten",
  manageServicesDesc: "Passe Preise, maximale Anzahl und Verfügbarkeit deiner Zusatzleistungen an.",
  menuCloseAria: "Menü schließen",
  menuOpenAria: "Menü öffnen",
  noServicesAvailable: "Keine Zusatzleistungen verfügbar.",
  remove: "Entfernen",
  servicesSaveError: "Speichern fehlgeschlagen.",
  servicesSavedToast: "Preise gespeichert.",
  statusHistorySection: "Status-Verlauf",
  statusUpdatedToast: "Status aktualisiert.",
};
const en = {
  bruttopreis: "Gross price",
  nettopreis: "Net price",
  couponNotAvailableForOffer: "Coupons cannot be used with your own price offer.",
  discardChanges: "Discard",
  saveChanges: "Save",
  errorCancelReasonRequired: "Please enter a cancellation reason.",
  expandCoupon: "Expand coupon",
  minimizeCoupon: "Collapse coupon",
  genericSaveError: "Saving failed. Please try again.",
  loadingAria: "Loading",
  manageServicesTitle: "Manage extra services",
  manageServicesDesc: "Adjust prices, maximum quantity and availability of your extra services.",
  menuCloseAria: "Close menu",
  menuOpenAria: "Open menu",
  noServicesAvailable: "No extra services available.",
  remove: "Remove",
  servicesSaveError: "Saving failed.",
  servicesSavedToast: "Prices saved.",
  statusHistorySection: "Status history",
  statusUpdatedToast: "Status updated.",
};
const tr = {
  bruttopreis: "Brüt fiyat",
  nettopreis: "Net fiyat",
  couponNotAvailableForOffer: "Kendi fiyat teklifinizde kuponlar kullanılamaz.",
  discardChanges: "Vazgeç",
  saveChanges: "Kaydet",
  errorCancelReasonRequired: "Lütfen bir iptal nedeni girin.",
  expandCoupon: "Kuponu genişlet",
  minimizeCoupon: "Kuponu küçült",
  genericSaveError: "Kaydedilemedi. Lütfen tekrar deneyin.",
  loadingAria: "Yükleniyor",
  manageServicesTitle: "Ek hizmetleri yönet",
  manageServicesDesc: "Ek hizmetlerinizin fiyatlarını, azami adedini ve kullanılabilirliğini ayarlayın.",
  menuCloseAria: "Menüyü kapat",
  menuOpenAria: "Menüyü aç",
  noServicesAvailable: "Ek hizmet bulunmuyor.",
  remove: "Kaldır",
  servicesSaveError: "Kaydedilemedi.",
  servicesSavedToast: "Fiyatlar kaydedildi.",
  statusHistorySection: "Durum geçmişi",
  statusUpdatedToast: "Durum güncellendi.",
};
const pl = {
  bruttopreis: "Cena brutto",
  nettopreis: "Cena netto",
  couponNotAvailableForOffer: "Kuponów nie można stosować przy własnej propozycji ceny.",
  discardChanges: "Odrzuć",
  saveChanges: "Zapisz",
  errorCancelReasonRequired: "Podaj powód anulowania.",
  expandCoupon: "Rozwiń kupon",
  minimizeCoupon: "Zwiń kupon",
  genericSaveError: "Zapis nie powiódł się. Spróbuj ponownie.",
  loadingAria: "Ładowanie",
  manageServicesTitle: "Zarządzaj usługami dodatkowymi",
  manageServicesDesc: "Dostosuj ceny, maksymalną liczbę i dostępność swoich usług dodatkowych.",
  menuCloseAria: "Zamknij menu",
  menuOpenAria: "Otwórz menu",
  noServicesAvailable: "Brak dostępnych usług dodatkowych.",
  remove: "Usuń",
  servicesSaveError: "Zapis nie powiódł się.",
  servicesSavedToast: "Ceny zapisane.",
  statusHistorySection: "Historia statusów",
  statusUpdatedToast: "Status zaktualizowany.",
};
const uk = {
  bruttopreis: "Ціна брутто",
  nettopreis: "Ціна нетто",
  couponNotAvailableForOffer: "Купони не діють разом із вашою пропозицією ціни.",
  discardChanges: "Скасувати",
  saveChanges: "Зберегти",
  errorCancelReasonRequired: "Вкажіть причину скасування.",
  expandCoupon: "Розгорнути купон",
  minimizeCoupon: "Згорнути купон",
  genericSaveError: "Не вдалося зберегти. Спробуйте ще раз.",
  loadingAria: "Завантаження",
  manageServicesTitle: "Керування додатковими послугами",
  manageServicesDesc: "Налаштуйте ціни, максимальну кількість і доступність ваших додаткових послуг.",
  menuCloseAria: "Закрити меню",
  menuOpenAria: "Відкрити меню",
  noServicesAvailable: "Додаткових послуг немає.",
  remove: "Видалити",
  servicesSaveError: "Не вдалося зберегти.",
  servicesSavedToast: "Ціни збережено.",
  statusHistorySection: "Історія статусів",
  statusUpdatedToast: "Статус оновлено.",
};
export default { de, en, tr, pl, uk };
